import React from 'react';
import { BoxAction, ProcessingType } from '../../../types';
import { DEFAULT_COMMODITY, DEFAULT_COMMODITY_FOUND } from '../../../utils';
import { OosDetectionForm } from './OosDetectionForm';

type ActionsFormProps = {
  action: BoxAction;
  processingType: ProcessingType;
  onUpdateAction: (bboxId: number, updates: Partial<BoxAction>) => void;
  experimental?: boolean;
};

export const ActionsForm: React.FC<ActionsFormProps> = ({
  action,
  processingType,
  onUpdateAction,
  experimental = false, // Experimental feature flag
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {!experimental && processingType === 'structured' && (
        <OosDetectionForm action={action} onUpdateAction={onUpdateAction} />
      )}

      {processingType === 'flex-space' && (
        <>
          <div>
            <h3 className="text-lg font-semibold mb-2">
              Flex Space Detection is not supported yet
            </h3>
            {/* <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Occupancy (0-1)
              </label>
              <input
                type="number"
                min="0"
                max="1"
                step="0.1"
                value={action.occupancy || ''}
                disabled
                onChange={(e) =>
                  onUpdateAction(action.bbox_id, {
                    occupancy: parseFloat(e.target.value),
                  })
                }
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div> */}
          </div>
        </>
      )}

      {processingType === 'coffee-machine' && (
        <>
          <div>
            <h3 className="text-lg font-semibold mb-2">
              Coffee Machine Detection is not supported yet
            </h3>
            {/* <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Occupancy (0-1)
              </label>
              <input
                type="number"
                min="0"
                max="1"
                step="0.1"
                value={action.occupancy || ''}
                disabled
                onChange={(e) =>
                  onUpdateAction(action.bbox_id, {
                    occupancy: parseFloat(e.target.value),
                  })
                }
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div> */}
          </div>
        </>
      )}

      {(experimental || processingType === 'structured-produce') && (
        <>
          <OosDetectionForm action={action} onUpdateAction={onUpdateAction} />
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Issue
            </label>
            <select
              value={action.produceIssue || ''}
              onChange={(e) =>
                onUpdateAction(action.bboxId, {
                  produceIssue: e.target.value as BoxAction['produceIssue'],
                })
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">None</option>
              <option value="faceOver">Face Over</option>
              <option value="presentability">Presentability</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Expected commodity
            </label>
            <input
              type="text"
              value={action.expectedCommodity || DEFAULT_COMMODITY}
              onChange={(e) =>
                onUpdateAction(action.bboxId, {
                  expectedCommodity: e.target.value,
                })
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Commodity Found(comma separated)
            </label>
            <input
              type="text"
              value={action.commodityFound || DEFAULT_COMMODITY_FOUND}
              onChange={(e) =>
                onUpdateAction(action.bboxId, {
                  commodityFound: e.target.value
                    .split(',')
                    .map((item) => item.trim()),
                })
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Occupancy (0-100)
            </label>
            <input
              type="number"
              min="0"
              max="100"
              step="1"
              value={action.occupancy ?? ''}
              onChange={(e) =>
                onUpdateAction(action.bboxId, {
                  occupancy: parseFloat(e.target.value),
                })
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </>
      )}
    </div>
  );
};
